import "../../../field.js";
import "#vendor/jquery_plugins/jquery.mask.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.InsuranceStep ??= {};

AppointmentBooking.Wizard.Views.InsuranceStep.SubscriberDateOfBirthField = class SubscriberDateOfBirthField extends (
  AppointmentBooking.Wizard.Views.Field
) {
  constructor() {
    super(...arguments);
    this.render = this.render.bind(this);
    this.decorateField = this.decorateField.bind(this);
  }

  // RENDERING

  render() {
    super.render(...arguments);
    this.decorateField();

    return this;
  }

  // PRIVATE

  decorateField() {
    return jQuery.when().then(() => this.$(":input[name=subscriber_date_of_birth]").mask("09/09/0000"));
  }
};
AppointmentBooking.Wizard.Views.InsuranceStep.SubscriberDateOfBirthField.prototype.template =
  "step/insurance/fields/subscriber_date_of_birth";
AppointmentBooking.Wizard.Views.InsuranceStep.SubscriberDateOfBirthField.prototype.className =
  "appointment-booking-wizard-insurance-step-date-field";
